export function getPassportNumber(id) {
    let identity = id.split(":"), indexOf = (identity, q) => identity.findIndex(item => q.toLowerCase() === item.toLowerCase());
    if (identity.length > 1) {
        if (indexOf(identity, "PASSPORT") >= 0) {
            return identity[identity.length - 1];
        }
    }
}